import React from "react";
import "../styles/Albums.css";
import AlbumsData from "../data/AlbumsData";
import MediaCard from "./MediaCard";
import { Card } from "react-bootstrap";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Row } from "react-bootstrap";
import { Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";

console.log(AlbumsData);
function Albums() {
  const history = useHistory();
  return (
    <div className="albums-root">
      {/* <MediaCard AlbumsData={AlbumsData}/> */}
      <Grid>
        <Row style={{ justifyContent: "center" }}>
          {AlbumsData.map((card, index) => (
            <Card className="media-card" style={{border: "none"}} key={index}>
              <Card.Img
                className="media-card-img"
                variant="top"
                src={card.cover}
              />
              <Card.Body className="media-card-body">
                <Card.Text className="media-card-title">{card.title}</Card.Text>
                <Card.Text className="media-card-date">
                  {card.releaseDate}
                </Card.Text>
                {card.songs.map((song, id) => (
                  <div key={id}>
                    <ul>
                      <li className="heart-list">
                        <Card.Text className="media-card-songs">
                          {song}
                        </Card.Text>
                      </li>
                    </ul>
                  </div>
                ))}
              </Card.Body>
              {/* <Button
                onClick={() =>
                  history.push(
                    `${card.title.replace(/\s+/g, "-").toLowerCase()}`
                  )
                }
                style={{
                  color: "#000",
                  fontSize: "16px",
                  background: "#FB78B0",
                  textTransform: "capitalize",
                  padding: "10px 20px",
                }}
              >
                More Info
              </Button> */}
            </Card>
          ))}
        </Row>
      </Grid>
    </div>
  );
}

export default Albums;
